module.exports = __webpack_public_path__ + "static/img/heroimage_wallet_small.8a864ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heroimage_wallet_small.png
// module id = 177
// module chunks = 1